import React from 'react';
import MaterialOption from './MaterialOption';
import type { MaterialOptionsListProps } from '../interfaces';
import { getMaterialOptionState } from './materialSelector.utils';
import './MaterialOptionsList.scss';

const MaterialOptionsList: React.FC<MaterialOptionsListProps> = ({
  materialPrices,
  selectedMaterial,
  cartItem,
  productId,
  itemId,
  onSelect,
}) => (
  <div className="material-scroll-wrapper">
    {materialPrices.map((material) => {
      const optionState = getMaterialOptionState(material, selectedMaterial, cartItem, productId, itemId);

      return (
        <MaterialOption
          key={material.materialName}
          material={material}
          isSelected={optionState.isSelected}
          disabled={optionState.disabledByInventory}
          iconUrl={optionState.iconUrl}
          toneClass={optionState.toneClass}
          onSelect={onSelect}
        />
      );
    })}
  </div>
);

export default React.memo(MaterialOptionsList);
